<template>
  <div class="column is-12 py-0">
    <div
      class="bookmark-card break-word"
      :class="[index == 0 ? 'mt-3' : '', {offline: bookmark.offline, 'has-image': bookmark.imageUrl}]"
    >
      <header
        class="columns is-mobile mb-0 mt-0"
        @click="bookmarkClick(bookmark)"
      >
        <div class="column pb-0">
          <a
            :href="bookmark.url"
            target="_blank"
            class="card-header-title"
            @click.exact.prevent
          >
            <img
              v-if="bookmark.faviconUrl"
              :src="bookmark.faviconUrl"
              class="favicon"
              @error="setPlaceholder"
            >

            {{ bookmark.title }}
          </a>
        </div>
        <div class="column pb-0 is-5-mobile is-3-tablet has-text-right">
          <time
            class="card-header-title px-0 has-text-right card-date"
            :datetime="$formatDate(bookmark.updatedAt)"
          >
            {{ $formatDate(bookmark.updatedAt) }}
          </time>
        </div>
      </header>
      <div
        class="columns mb-0 is-gapless is-mobile"
        @dblclick="openViaExtension(bookmark)"
      >
        <div
          class="column py-0 pr-0"
        >
          <div class="card-content pt-1 pb-3 px-4">
            <div class="content description-wrap">
              {{ bookmark.description }}
            </div>
            <div class="content is-small">
              <BookmarkUrl
                :url="bookmark.url"
              />
            </div>
          </div>
        </div>
        <div
          v-if="bookmark.imageUrl"
          class="column is-4-mobile is-4-tablet is-3-desktop is-2-widescreen py-0 pl-0"
        >
          <a
            :href="bookmark.url"
            target="_blank"
            @click.exact.prevent
          >
            <b-image
              :src="bookmark.imageUrl"
              :alt="bookmark.title"
              ratio="5by1"
              class="bookmark-image"
              @error="setPlaceholder"
            />
          </a>
        </div>
      </div>
      <footer
        class="card-footer"
        @dblclick="openViaExtension(bookmark)"
      >
        <TagList
          :tags="tagsNames(bookmark.tags)"
          :selected-tags="selectedTags"
          class="card-footer-item"
          @tagClicked="addTag"
        />

        <BookmarkActionsMenu
          :bookmark="bookmark"
          :show-open="true"
          @openViaExtension="openViaExtension"
          @editRecord="editRecord"
          @confirmDeleted="confirmDelete"
          @deletedSelected="deleteSelected"
          @reparse="reparse"
          @wayback="wayback"
        />
      </footer>
    </div>
  </div>
</template>

<script>
  // import Vue from 'vue'
  import TagList from '@/qlipmark-shared/components/tags/TagList.vue'
  import BookmarkUrl from '@/components/bookmarks/BookmarkUrl.vue'
  import BookmarkActionsMenu from '@/components/bookmarks/BookmarkActionsMenu.vue'

  export default {
    name: 'BookmarkCardRegular',
    components: {
      TagList,
      BookmarkUrl,
      BookmarkActionsMenu
    },
    props: ['bookmark', 'index', 'selectedTags', 'tagsNames'],
    data: function() {
      return {
        bookmarkClickTimeout: null
      }
    },
    methods: {
      addTag(tag) {
        this.$emit('tagClicked', tag)
      },
      confirmDelete(id) {
        this.$emit('confirmDeleted', id)
      },
      deleteSelected(id) {
        this.$emit('deletedSelected', id)
      },
      editRecord(id) {
        this.$emit('editRecord', id)
      },
      reparse(id) {
        this.$emit('reparse', id)
      },
      wayback(bookmark) {
        this.$emit('wayback', bookmark)
      },
      openViaExtension(bookmark) {
        this.$emit('openUrlInFrame', bookmark)
      },
      setPlaceholder(e) {
        // e.target.classList.add('placeholder')
        e.target.src = "/images/defaults/globe-americas-solid.svg"
      },
      bookmarkClick(bookmark) {
        if(!this.bookmarkClickTimeout) {
          this.bookmarkClickTimeout = setTimeout(() => {
            this.bookmarkClickTimeout = null
            window.open(bookmark.url);
          }, 200);//tolerance in ms
        } else {
          clearTimeout(this.bookmarkClickTimeout)
          this.bookmarkClickTimeout = null
          this.$emit('openUrlInFrame', bookmark)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .offline {
    // background: #f9f9f9;
    border: 1px solid #e0e0e0;
    position: relative;

    &:before {
      font-family: 'Font Awesome\ 5 Free';
      content: '\f070\ offline';
      color: #838182;
      position: absolute;
      right: -3px;
      top: -3px;
      background: #ededed;
      padding: 2px 4px;
      border-radius: 6px;
      z-index: 1;
      font-size: 14px;
      opacity: 0.7;
    }

    * {
      transition: opacity 0.3s ease-in-out;
      opacity: 0.7;
    }

    &:hover * { opacity: 1; }
  }

  .bookmark-image {
    height: 100%;
    padding-top: 0;
    border-right: 1px solid #ededed;
  }

  .favicon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    // vertical-align: middle;
    margin-top: 5px;
    align-self: baseline;

    float: left;
    margin-top: 0.2rem;

    &.placeholder {
      color: #ccc;
    }
  }

  .card-content,
  .card-date {
    color: rgba(119, 124, 150, 0.9);
  }

  .card-header-title {
    font-size: 16px;
  }

  .card-content {
    font-size: 14px;
  }

  .card-date {
    display: inline-block;
    font-weight: normal;
    font-size: 12px;
    margin-right: 16px;
  }

  // .has-image .card-date {
  //   margin-right: 0px;
  // }
</style>
